module.exports = __webpack_public_path__ + "img/ads-from-scratch.e657fdcb.svg";